import script from "./StoreHoursScript.vue?vue&type=script&lang=js"
export * from "./StoreHoursScript.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__